import logo from './logo.svg';
import MeterTable from './HomePage';
import Header from './Header';
import './App.css';

function App() {
  return (
    <>
      <Header />
      <MeterTable />
    </>
  );
}

export default App;
